window.bundleapp = window.bundleapp || {};
window.bundleapp.settings = Object.assign({}, window.bundleapp.settings || {}, {
  bab: {
    productImage: 600
  }
});

const waitForElement = (selector, callback, delay = 0, failsafeDelay) => {
  const observer = new MutationObserver((mutations, obs) => {
    const element = document.querySelector(selector);
    if (element) {
      obs.disconnect();
      if (typeof callback === "function") {
        setTimeout(() => {
          callback(element);
        }, delay);
      }
    }
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });

  if (failsafeDelay) setTimeout(() => observer.disconnect(), failsafeDelay);
};

const babMinimums = {
  // Example structure:
  // "9556565229815": {
  //   49231431958775: 60,
  //   49231431991543: 120
  // }
};

//if awtomic allocation page like https://kpvjpx-he.myshopify.com/tools/bundle-subscriptions/allocation/265
if (window.location.pathname.includes("/tools/bundle-subscriptions/allocation/")) {
  document.body.classList.add("awt-allocation");
  const allocationId = window.location.pathname.split("/").pop();
  if (allocationId) {
    document.body.classList.add(`awt-allocation-${allocationId}`);
  }
}

// Seasonal introduction at the top of the allocation portal.
//
// The allocation portal has no header field, in the app or in the admin, so the
// text is added here. Edit the lines in `introHtml` for each new release.
// The block runs one time. It checks for an existing intro first, so a re-render
// cannot add a second copy.
if (window.location.pathname.includes("/tools/bundle-subscriptions/allocation/")) {
  const introHtml = `
    <h2 class="heading text-text h1 text-center uppercase">Welcome to Turley's 2024 Vintage Fall Release!</h2>
    <div class="text-block rte-content">
    <p>We're delighted to share this season's newest releases with you. We hope you enjoy exploring the collection and discovering a few new favorites.</p>
    <p><strong>Please Note:</strong></p>
    <ul>
      <li>Wines are available on a first-come, first-served basis while supplies last.</li>
      <li>For the best shipping rates, we recommend ordering in increments of 3 bottles.</li>
      <li>A 3-bottle minimum is required to order.</li>
      <li>Pick-ups will be available in mid-October through December 31st. To select pick-up, go to the Shipment Info section at checkout, choose “Edit,” then select “Pickup.”</li>
      <li>Shipping is available October 20th — December 15th, weather permitting. Preferred ship
dates are selected at checkout.</li>
    </ul>
    <p>Thank you for being part of the Turley family!</p>
    </div>
  `;

  waitForElement("#allocation-app", (app) => {
    if (document.querySelector(".awt-allocation-intro")) return;
    const intro = document.createElement("div");
    intro.className = "awt-allocation-intro";
    intro.innerHTML = introHtml;
    app.parentNode.insertBefore(intro, app);
  }, 0, 15000);
}

// Allocation portal: drop the "Wishlist disabled." sentence from a product card label,
// and block the week of Thanksgiving in the shipping date picker.
//
// 1. THE LABEL. AllocationProductCard renders one span per card:
//      <span class="chakra-text allocation-product-card__label ...">Limit 9. Wishlist disabled.</span>
//    The text comes from i18n, and the two strings that carry the sentence are
//      limit_max_wishlist_disabled     "Limit {{max}}. Wishlist disabled."
//      select_min_max_wishlist_disabled "Select {{min}} - {{max}}. Wishlist disabled."
//    Only the sentence is removed, so "Limit 9." survives. Hiding the whole span
//    would also hide the limit, which the customer needs.
//    The SAME sentence reaches the slide-out details panel. A click on a card opens
//    the panel, and the panel receives the card label as its subtitle. The panel
//    prints the subtitle as a plain <h3> inside .bundle-slideout-title-container,
//    with no class of its own, so the card selector alone does not match it. Both
//    selectors are below, and the sentence test keeps every other <h3> unchanged.
//    🔴 ENGLISH ONLY. The match is on the English sentence. A storefront in another
//    language keeps its label unchanged, silently.
//
// 2. THE DATE PICKER. Turley runs the picker in RANGE mode - the calendar - which is
//    why the weekend rule further down this theme works. Each day cell is a
//    .react-datepicker__day; the month it belongs to is printed in
//    .react-datepicker__current-month. Cells carrying react-datepicker__day--outside-month
//    belong to a neighbouring month and are skipped. A blocked cell gets aria-disabled
//    and the class awt-date-blocked, which the CSS greys out and makes unclickable.
//    🔴 THE DATES ARE A GUESS AND YOU MUST CHECK THEM. Thanksgiving 2026 falls on
//    Thursday 26 November. BLOCKED_SHIPPING_DATES below covers Monday 23 to Friday 27.
//    Weekends are already disabled by the rule further down, so the working week is
//    covered. If Turley means a different span, edit the list - it is the only place.
if (window.location.pathname.includes("/tools/bundle-subscriptions/allocation/")) {
  const WISHLIST_SENTENCE = /\s*Wishlist disabled\.\s*$/;

  // ISO dates, one per blocked day. Edit this list for another release.
  const BLOCKED_SHIPPING_DATES = [
    "2026-11-23",
    "2026-11-24",
    "2026-11-25",
    "2026-11-26",
    "2026-11-27"
  ];

  const MONTHS = [
    "January", "February", "March", "April", "May", "June",
    "July", "August", "September", "October", "November", "December"
  ];

  // 1st selector: the product card label. 2nd: the slide-out details panel subtitle.
  const WISHLIST_LABEL_SELECTOR = [
    "#allocation-app .allocation-product-card__label",
    ".bundle-slideout-title-container h3"
  ].join(", ");

  const cleanWishlistLabels = () => {
    document
      .querySelectorAll(WISHLIST_LABEL_SELECTOR)
      .forEach((label) => {
        const text = label.textContent || "";
        if (!WISHLIST_SENTENCE.test(text)) return;
        label.textContent = text.replace(WISHLIST_SENTENCE, "");
      });
  };

  // "November 2026" -> { month: 10, year: 2026 }; null when the header is missing
  // or worded differently, in which case no day is blocked this pass.
  const readVisibleMonth = (calendar) => {
    const header = calendar.querySelector(".react-datepicker__current-month");
    if (!header) return null;
    const parts = (header.textContent || "").trim().split(/\s+/);
    if (parts.length < 2) return null;
    const month = MONTHS.indexOf(parts[0]);
    const year = parseInt(parts[1], 10);
    if (month === -1 || !Number.isFinite(year)) return null;
    return { month, year };
  };

  const pad = (n) => String(n).padStart(2, "0");

  const blockShippingDates = () => {
    document.querySelectorAll(".react-datepicker").forEach((calendar) => {
      const visible = readVisibleMonth(calendar);
      if (!visible) return;
      calendar.querySelectorAll(".react-datepicker__day").forEach((day) => {
        if (day.classList.contains("react-datepicker__day--outside-month")) return;
        const dayNumber = parseInt((day.textContent || "").trim(), 10);
        if (!Number.isFinite(dayNumber)) return;
        const iso = `${visible.year}-${pad(visible.month + 1)}-${pad(dayNumber)}`;
        const blocked = BLOCKED_SHIPPING_DATES.indexOf(iso) !== -1;
        day.classList.toggle("awt-date-blocked", blocked);
        if (blocked) {
          day.setAttribute("aria-disabled", "true");
        } else if (day.getAttribute("aria-disabled") === "true" &&
                   !day.classList.contains("react-datepicker__day--disabled")) {
          day.removeAttribute("aria-disabled");
        }
      });
    });
  };

  // 3. THE LOCAL PICKUP READY TIME. Shopify writes this string, not Awtomic: it is
  //    localPickupSettingsV2.pickupTime on the location (AllocationDraftContext.tsx:62),
  //    so there is no Awtomic setting that turns it off and no Awtomic literal to change.
  //    The only place to remove it is here, in the rendered page.
  //    The text node is removed, NOT the card - the location name, address and phone all
  //    stay. Removing a text node cannot orphan the elements around it.
  //    🔴 ENGLISH ONLY, and it matches on Shopify's wording. If Shopify rewords the string,
  //    or the storefront is in another language, this stops matching and the line comes
  //    back. It fails visible, not broken.
  const PICKUP_READY_TIME = /^\s*Usually ready in\b/i;

  const hidePickupReadyTime = () => {
    const app = document.querySelector("#allocation-app");
    if (!app) return;
    const walker = document.createTreeWalker(app, NodeFilter.SHOW_TEXT, null);
    const doomed = [];
    let node = walker.nextNode();
    while (node) {
      if (PICKUP_READY_TIME.test(node.nodeValue || "")) doomed.push(node);
      node = walker.nextNode();
    }
    doomed.forEach((textNode) => {
      const parent = textNode.parentNode;
      textNode.parentNode.removeChild(textNode);
      // A <div>Usually ready in 5+ days</div> would leave an empty box behind.
      if (parent && parent !== app && !parent.textContent.trim() && !parent.children.length) {
        parent.style.display = "none";
      }
    });
  };

  const applyAllocationTweaks = () => {
    cleanWishlistLabels();
    blockShippingDates();
    hidePickupReadyTime();
  };

  // A blocked day fires no click through CSS, but the calendar re-renders on every
  // month change, so this catches a click that lands before the next pass.
  document.addEventListener(
    "click",
    (event) => {
      const day = event.target.closest && event.target.closest(".awt-date-blocked");
      if (day) {
        event.preventDefault();
        event.stopPropagation();
      }
    },
    true
  );

  let allocationTweakPending = false;
  const allocationObserver = new MutationObserver(() => {
    if (allocationTweakPending) return;
    allocationTweakPending = true;
    requestAnimationFrame(() => {
      allocationTweakPending = false;
      applyAllocationTweaks();
    });
  });
  allocationObserver.observe(document.body, { childList: true, subtree: true });

  applyAllocationTweaks();
}

// Minimum bottle count for the allocation portal.
//
// The allocation app has no minimum-quantity setting, so the rule is enforced
// here: the allocation primary CTA carries the disabled attribute until the
// selection reaches the minimum. The app labels that CTA "Confirm purchase" when
// the customer has a saved card and "Continue" when they do not, so both labels
// are matched. Change the number below for a release with another rule.
const ALLOCATION_MINIMUM_BOTTLES = 3;

if (window.location.pathname.includes("/tools/bundle-subscriptions/allocation/")) {
  // Marks a button that we disabled, so a later pass can tell our state from the
  // app's own. The app disables the button while it saves, and that is left alone.
  const LOCK_ATTR = "data-awt-minimum-lock";
  const NOTICE_CLASS = "awt-allocation-min-notice";
  const NOTICE_TEXT = `Select at least ${ALLOCATION_MINIMUM_BOTTLES} bottles to continue.`;

  // Each product card carries its own count in data-quantity.
  const countSelectedBottles = () =>
    Array.from(document.querySelectorAll("#allocation-app .bundle-product-card")).reduce(
      (total, card) => total + (parseInt(card.getAttribute("data-quantity"), 10) || 0),
      0
    );

  // Both copies of the button: the one in the summary column and the one that
  // follows the product grid on a narrow screen. Matches either CTA label
  // ("Confirm purchase" with a saved card, "Continue" without one).
  const confirmButtons = () =>
    Array.from(document.querySelectorAll("#allocation-app button.bundle-button.button--primary")).filter((button) =>
      /confirm|continue/i.test(button.textContent || "")
    );

  let minimumMet = true;

  const applyMinimum = () => {
    minimumMet = countSelectedBottles() >= ALLOCATION_MINIMUM_BOTTLES;
    document.body.classList.toggle("awt-allocation-min-not-met", !minimumMet);

    confirmButtons().forEach((button) => {
      if (!minimumMet) {
        if (!button.disabled) {
          button.disabled = true;
          button.setAttribute(LOCK_ATTR, "");
        }
      } else if (button.hasAttribute(LOCK_ATTR)) {
        button.removeAttribute(LOCK_ATTR);
        button.disabled = false;
      }

      // A re-render can replace the button and drop the note with it, so put it back.
      const container = button.parentNode;
      if (container && !container.querySelector(`.${NOTICE_CLASS}`)) {
        const notice = document.createElement("p");
        notice.className = NOTICE_CLASS;
        notice.textContent = NOTICE_TEXT;
        container.appendChild(notice);
      }
    });
  };

  // A disabled button fires no click, but the app re-renders often, so this
  // catches a click that lands before the next pass restores the attribute.
  document.addEventListener(
    "click",
    (event) => {
      if (minimumMet) return;
      const button = event.target.closest && event.target.closest("button.bundle-button.button--primary");
      if (button && button.closest("#allocation-app") && /confirm|continue/i.test(button.textContent || "")) {
        event.preventDefault();
        event.stopPropagation();
      }
    },
    true
  );

  // Quantity changes write data-quantity on a card, and some updates re-render
  // the whole grid, so watch for both. One pass per frame at most.
  let pending = false;
  const observer = new MutationObserver(() => {
    if (pending) return;
    pending = true;
    requestAnimationFrame(() => {
      pending = false;
      applyMinimum();
    });
  });
  observer.observe(document.body, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ["data-quantity", "disabled"]
  });

  applyMinimum();
}

//if awtomic customer portal
if (window.location.pathname.includes("/tools/bundle-subscriptions") && window.location.search.includes("subscriptionId=")) {
  document.body.classList.add("awt-cp");

  // CP PRICE CHECK
  waitForElement(".bundle-table__body-row--bab-parent", (element) => {
    const checkBabEdit = (bundleId, variantId) => {
      const minimumPrice = babMinimums[bundleId]?.[variantId] || 0;

      const setAddToCartMinimumPrice = () => {
        const bundleContainer = document.querySelector(".bundleapp-modal__container--complete-screen > .bundle-container");

        if (!bundleContainer) return;

        const infoDiv = document.createElement("div");
        infoDiv.className = "minimum-price-info";
        infoDiv.innerText = `Minimum price of $${minimumPrice} is required for this club.`;

        const footerDiv = bundleContainer.querySelector("footer > div");
        if (footerDiv) {
          const lastDiv = footerDiv.querySelector("div:last-child");
          if (lastDiv) {
            footerDiv.insertBefore(infoDiv, lastDiv);
          }
        }

        document.body.addEventListener("click", (e) => {
          const price = document.querySelector("div > span.bundle-text--emphasis").innerText;
          const innerPrice = parseFloat(price.replace(/[^0-9.,]/g, "").replace(",", ""));

          const addToCartButton = document.querySelector(".bundleapp-modal__container--complete-screen footer > div > div > button");
          if (innerPrice < minimumPrice) {
            addToCartButton.classList.add("priceNotMet");
            document.body.classList.add("priceNotMet");
          } else {
            addToCartButton.classList.remove("priceNotMet");
            document.body.classList.remove("priceNotMet");
          }
        });
      };

      const checkIfPriceLabel = () =>
        document.querySelector(".bundleapp-modal__container--complete-screen footer > div > div:last-child > div > span:nth-child(2)");

      let priceLabelSet = false;

      if (checkIfPriceLabel()) {
        setAddToCartMinimumPrice();
      } else {
        const observer = new MutationObserver((mutations) => {
          mutations.forEach((mutation) => {
            if (!priceLabelSet && mutation.addedNodes.length) {
              if (checkIfPriceLabel()) {
                setAddToCartMinimumPrice();
                priceLabelSet = true;
                observer.disconnect();
              }
            }
          });
        });

        observer.observe(document.body, {
          childList: true,
          subtree: true
        });

        setTimeout(() => {
          observer.disconnect();
        }, 5000);
      }
    };

    Object.keys(babMinimums).forEach((bundleId) => {
      Object.keys(babMinimums[bundleId]).forEach((variantId) => {
        const selector = `tr[class*="${variantId}"]`;
        const element = document.querySelector(selector);
        console.log(selector, element);
        if (element) element.addEventListener("click", () => checkBabEdit(bundleId, variantId));
      });
    });
  });
}

//if awtomic subs list / my subscriptions
if (/^\/tools\/bundle-subscriptions\/?$/.test(location.pathname) && !location.search) {
  document.body.classList.add("awt-my-subs");
}

//if awtomic bab purchase flow
if (window.location.pathname.includes("/tools/bundle-subscriptions/bundle/")) {
  window.Awtomic = window.Awtomic || {};
  window.Awtomic.getBabSelection = () => {
    //babProductId is in a class of an element, the element is div.bundle-container.pv_xxxxxxx where xxxxxxx is the bab product id
    const babProductId = document
      .querySelector(".bundle-container")
      ?.className.split(" ")
      .find((c) => c.startsWith("pv_"))
      ?.split("_")[1];
    if (!babProductId) return { object: {}, queryString: "" };

    const bundleProductCards = document.querySelectorAll(".bundle-product-card");

    const bundleSelectedProducts = {};
    bundleProductCards.forEach((card) => {
      const productId = card.getAttribute("data-pid");
      const quantityElement = card.querySelector(".bundle-product-card__quantity-button-container > span");
      const quantity = quantityElement ? parseInt(quantityElement.innerHTML) : 0;

      if (productId && quantity > 0) {
        bundleSelectedProducts[productId] = quantity;
      }
    });

    // Create query string format
    const queryString = Object.entries(bundleSelectedProducts)
      .map(([id, quantity]) => `${id}=${quantity}`)
      .join("&");

    // Create full URL with query string
    const currentUrl = window.location.href;
    const separator = currentUrl.includes("?") ? "&" : "?";
    const fullUrl = queryString ? `${currentUrl}${separator}${queryString}` : currentUrl;

    return {
      object: { [babProductId]: bundleSelectedProducts },
      queryString: queryString,
      fullUrl: fullUrl
    };
  };

  const urlParts = window.location.pathname.split("/");
  const bundleId = urlParts[urlParts.length - 1];
  if (bundleId) {
    document.body.classList.add(`awt-bundle-${bundleId}`);

    if (babMinimums[bundleId]) {
      // Wait for footer to exist first, then set up the price checking
      waitForElement(".bundleapp-modal__container--complete-screen footer", () => {
        // Get variant ID from bundle container classes (e.g., div.bundle-container p_9556565229815.pv_49231431991543)
        const getVariantId = () => {
          const bundleContainer = document.querySelector(".bundle-container");
          if (!bundleContainer) return null;

          const classes = bundleContainer.className.split(" ");
          const variantClass = classes.find((c) => c.startsWith("pv_"));
          return variantClass ? variantClass.split("_")[1] : null;
        };

        let currentVariantId = getVariantId();

        const updatePriceChecking = (variantId) => {
          const minimumPrice = babMinimums[bundleId]?.[variantId] || 0;
          console.log(`Setting up price checking for variant ${variantId} with minimum price $${minimumPrice}`);

          const setAddToCartMinimumPrice = () => {
            const bundleContainer = document.querySelector(".bundleapp-modal__container--complete-screen > .bundle-container");

            if (!bundleContainer) return;

            // Remove existing minimum price info if any
            const existingInfo = bundleContainer.querySelector(".minimum-price-info");
            if (existingInfo) {
              existingInfo.remove();
            }

            const infoDiv = document.createElement("div");
            infoDiv.className = "minimum-price-info";
            infoDiv.innerText = `Minimum price of $${minimumPrice} is required for this club.`;

            const footerDiv = bundleContainer.querySelector("footer > div");
            if (footerDiv) {
              const lastDiv = footerDiv.querySelector("div:last-child");
              if (lastDiv) {
                footerDiv.insertBefore(infoDiv, lastDiv);
              }
            }

            document.body.addEventListener("click", (e) => {
              const price = document.querySelector("div > span.bundle-text--emphasis").innerText;
              const innerPrice = parseFloat(price.replace(/[^0-9.,]/g, "").replace(",", ""));

              const addToCartButton = document.querySelector(".bundleapp-modal__container--complete-screen footer > div > div > button");
              if (innerPrice < minimumPrice) {
                addToCartButton.classList.add("priceNotMet");
                document.body.classList.add("priceNotMet");
              } else {
                addToCartButton.classList.remove("priceNotMet");
                document.body.classList.remove("priceNotMet");
              }
            });
          };

          const checkIfPriceLabel = () =>
            document.querySelector(".bundleapp-modal__container--complete-screen footer > div > div:last-child > div > span:nth-child(2)");

          let priceLabelSet = false;

          if (checkIfPriceLabel()) {
            setAddToCartMinimumPrice();
          } else {
            const observer = new MutationObserver((mutations) => {
              mutations.forEach((mutation) => {
                if (!priceLabelSet && mutation.addedNodes.length) {
                  if (checkIfPriceLabel()) {
                    setAddToCartMinimumPrice();
                    priceLabelSet = true;
                    observer.disconnect();
                  }
                }
              });
            });

            observer.observe(document.body, {
              childList: true,
              subtree: true
            });

            setTimeout(() => {
              observer.disconnect();
            }, 5000);
          }
        };

        // Initial setup if we have a variant ID
        if (currentVariantId) {
          updatePriceChecking(currentVariantId);
        }

        // Watch for variant changes in the bundle container
        const variantObserver = new MutationObserver((mutations) => {
          mutations.forEach((mutation) => {
            if (mutation.type === "attributes" && mutation.attributeName === "class") {
              const newVariantId = getVariantId();
              if (newVariantId && newVariantId !== currentVariantId) {
                console.log(`Variant changed from ${currentVariantId} to ${newVariantId}`);
                currentVariantId = newVariantId;
                updatePriceChecking(currentVariantId);
              }
            }
          });
        });

        // Observe the bundle container for class changes
        const bundleContainer = document.querySelector(".bundle-container");
        if (bundleContainer) {
          variantObserver.observe(bundleContainer, {
            attributes: true,
            attributeFilter: ["class"]
          });
        }
      });
    }
  }
}

//cart rollup
document.body.addEventListener("click", async (event) => {
  if (!event.target.matches(".cart__remove-bundle *, .cart__remove-bundle[data-bundle-id]")) return;

  const bundleElement = event.target.closest(".cart__remove-bundle") || (event.target.hasAttribute("data-bundle-id") ? event.target : null);
  const bundle_id = bundleElement ? bundleElement.getAttribute("data-bundle-id") : null;

  if (bundle_id) {
    event.preventDefault();
    try {
      // Get current cart contents
      const cart = await (await fetch("/cart.js")).json();

      // Create data object for cart update AJAX call
      const data = {
        updates: cart.items.reduce((acc, item) => (item.properties?._bundleUid == bundle_id ? { ...acc, [item.key]: 0 } : acc), {})
      };

      // API call to update the cart contents and set the bundle item quantities to 0
      const response = await fetch("/cart/update.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(data)
      });

      response.ok && (window.location.href = "/cart");
    } catch (error) {
      console.error(error);
    }
  }
});

//wine club sign-up form: clear the shipping address and the card-holder name
//
// The sign-up kit already starts these fields empty. assets/wcs-main.js sets the
// shipping address to { countryCode: "US" } and the card-holder name to two empty
// strings. Members still report a filled address, so this block is a second guard.
// It does not correct a known defect. It removes any value that reaches the fields
// from another source, for example the browser autofill.
//
// The block clears each field one time, when the field first appears. Then it stops.
// A member who types after that keeps the text that they type.
if (window.location.pathname.includes("/pages/membership-form")) {
  const clearSignupField = (el) => {
    if (!el) return;
    el.value = "";
    // The kit holds its own copy of each value and sends that copy to the server.
    // An input reads the "input" event and a select reads the "change" event.
    // Send the event, or the kit keeps the old value.
    el.dispatchEvent(new Event(el.tagName === "SELECT" ? "change" : "input", { bubbles: true }));
    // Stop the browser from filling the field again.
    el.setAttribute("autocomplete", "off");
  };

  // The kit builds the form after the member signs in, so wait for each block.
  // waitForElement only reacts to a change, thus test for the block first.
  const onSignupBlock = (selector, callback) => {
    const el = document.querySelector(selector);
    if (el) {
      callback(el);
      return;
    }
    waitForElement(selector, callback, 0, 60000);
  };

  // Shipping address. Keep the country field. wcs-main.js sets the country to "US",
  // and the kit reads the list of states from that value.
  onSignupBlock('.wcs-address[data-name="shipping"]', (block) => {
    block.querySelectorAll("input, select").forEach((el) => {
      if (el.closest('[data-field="country"]')) return;
      clearSignupField(el);
    });
  });

  // Card-holder name.
  onSignupBlock("#wcs-card-first", () => {
    clearSignupField(document.querySelector("#wcs-card-first"));
    clearSignupField(document.querySelector("#wcs-card-last"));
  });
}